import { useEffect } from "react"
import { aIsMuted, aIsPlaying, useAtom } from "~/atoms"

export default function useKeyboardShortcuts() {
  const [isPlaying, setIsPlaying] = useAtom(aIsPlaying)
  const [isMuted, setIsMuted] = useAtom(aIsMuted)

  useEffect(() => {
    const onKeyUp = (e: KeyboardEvent) => {
      if (e.key === " " && (e.target as HTMLElement).tagName === "BUTTON") return
      if (e.key === "k" || e.key === " ") {
        setIsPlaying(!isPlaying)
      } else if (e.key === "m") {
        setIsMuted(!isMuted)
      }
    }

    window.addEventListener("keyup", onKeyUp)

    return () => {
      window.removeEventListener("keyup", onKeyUp)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isPlaying, isMuted])
}
